module.exports = __webpack_public_path__ + "static/media/Vector.b2891cc7.png";